import React from 'react'
import styled from 'styled-components'
import { useCreationSourcePreviewUrl } from '../../../hooks/use-creation-source-preview-url'
import { CreationToolSourceFile } from '../../../types'
import { StickerBlock } from '../../blocks'
import { SourceEditorEdits } from '../../source-editor/types'

const Image = styled(StickerBlock)`
    position: relative;
    width: 100%;

    img {
        display: block;
        width: 100%;
    }
`

type Props = {
    className?: string
    source: CreationToolSourceFile
    edits?: SourceEditorEdits
}

const CreationSourcePlayerImage = ({ className, source: { source } }: Props) => {
    const src = useCreationSourcePreviewUrl(source)

    return (
        <Image className={className}>
            <img src={src} alt="" />
        </Image>
    )
}

export default CreationSourcePlayerImage
